import { toMajorUnits } from "~/lib/shared/currency";

/**
 * Format a Stripe amount (the currency's smallest unit) as a whole-unit
 * currency string, e.g. 12900 USD → "$129" and 45000 JPY → "¥45,000".
 * Aliases: price format, money format, currency format.
 */
export function formatPrice(price: number, currency: string): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(toMajorUnits(price, currency));
}
